import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import SearchBar from "components/commonSearch/SearchBar";
import Loader from "components/loader/Loader";
import star from "assets/images/smStar.svg";
import image from "assets/images/ProfileVendor.svg";

function AllotDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    allotData,
    openDialog,
    title,
    titleType,
    placeholder,
    subtitle,
    type,
    onSearch,
  } = props;

  const handleClose = () => {
    props?.handleClose();
  };

  const onSubmit = (data) => {
    props?.submittAssign(data);
  };

  const handleOnError = (e) => {
    e.target.src = image;
  };

  const typeName = (type, data) => {
    if (type === "Sub-Vendor") {
      return data?.companyName;
    } else if (data?.driverName) {
      return data?.driverName;
    } else {
      return data?.name;
    }
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        fullWidth
        maxWidth="md"
        className={!fullScreen ? "dialogStyle" : ""}
        PaperProps={{
          sx: fullScreen
            ? {
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                bgcolor: "white",
                mx: 1.5,
                borderRadius: 2,
              }
            : {},
        }}
      >
        {/* ---Header section (title + close)--- */}
        <DialogTitle
          sx={{
            position: fullScreen ? "sticky" : "static",
            top: 0,
            zIndex: 5,
            bgcolor: "white",
            borderBottom: fullScreen ? "1px solid #eee" : "none",
            px: fullScreen ? 2 : 3,
            py: fullScreen ? 1.5 : 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: fullScreen ? "20px" : "28px",
              fontWeight: 600,
              color: "#003366",
            }}
          >
            {title} <span style={{ color: "#FFA500" }}>{titleType}</span>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: "#333",
              backgroundColor: fullScreen ? "#f5f5f5" : "transparent",
              "&:hover": { backgroundColor: "#e0e0e0" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* ---Body section--- */}
        <DialogContent
          sx={{
            flex: 1,
            overflowY: "auto",
            px: fullScreen ? 2 : 4,
            pb: fullScreen ? 2 : 4,
          }}
        >
          <SearchBar placeholder={placeholder} onSearch={onSearch} />

          <DialogContentText sx={{ mt: 2 }}>
            {props?.loader ? (
              <Loader />
            ) : allotData?.length > 0 ? (
              allotData.map((ele) => (
                <Grid
                  container
                  key={ele.id}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                    px: fullScreen ? 1 : 0,
                    py: 1,
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  {/* Avatar + Name + Phone */}
                  <Grid
                    item
                    xs={8}
                    md={6}
                    container
                    alignItems="center"
                    sx={{
                      flexWrap: "nowrap",
                      gap: fullScreen ? 1.5 : 2,
                    }}
                  >
                    <img
                      src={ele?.avtar?.url || image}
                      alt="profile"
                      onError={handleOnError}
                      style={{
                        width: fullScreen ? 45 : 60,
                        height: fullScreen ? 45 : 60,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    <div>
                      <Typography
                        sx={{
                          fontSize: fullScreen ? 16 : 18,
                          fontWeight: 500,
                        }}
                      >
                        {typeName(titleType, ele)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: fullScreen ? 13 : 14,
                          color: "#777",
                        }}
                      >
                        {ele?.mobile}
                      </Typography>
                    </div>
                  </Grid>

                  {/* Assign Button */}
                  <Grid
                    item
                    xs={4}
                    md={2}
                    textAlign="right"
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <button
                      className="assignBtn cursor"
                      style={{
                        padding: fullScreen ? "6px 10px" : "6px 14px",
                        fontSize: fullScreen ? "13px" : "14px",
                        borderRadius: "6px",
                        background: "#0a4b84",
                        color: "#fff",
                        border: "none",
                        width: fullScreen ? "70px" : "auto",
                      }}
                      onClick={() => onSubmit(ele)}
                    >
                      Assign
                    </button>
                  </Grid>
                </Grid>
              ))
            ) : (
              <Grid item>
                <CommonNoDataFound />
              </Grid>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AllotDialog;
